import { useMemo } from 'react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { ActiveStatusChip } from './active-status-chip';
import { DisabledStatusChip } from './disabled-status-chip';
import { EditableStatusChipProps } from './types';

export const EditableStatusChip = ({
  appointmentDetails,
  disabled,
  disabledTooltipText,
  isIntegrated,
  wrapperStyle,
  ...restProps
}: EditableStatusChipProps) => {
  const { t } = useTranslation('appointment-status');

  const { data: dataSourcesData } = SchedulerV3.Helpers.useGetDataSourcesForLocation({
    locationId: appointmentDetails?.locationId || '',
    isEnabled: !!appointmentDetails?.locationId && isIntegrated,
  });

  const isWritebackEnabled = useMemo(
    () =>
      dataSourcesData?.dataSources?.some((dataSource) =>
        dataSource.integration?.capabilities?.find(
          (capability) => capability.dataType === 'APPOINTMENT_STATUS' && capability.operation === 'LIST'
        )
      ),
    [dataSourcesData?.dataSources]
  );

  if (isIntegrated && !isWritebackEnabled) {
    return (
      <DisabledStatusChip
        disabledTooltipText={t('Appointment status writeback is not supported')}
        wrapperStyle={wrapperStyle}
        {...restProps}
      />
    );
  }

  if (disabled) {
    return <DisabledStatusChip disabledTooltipText={disabledTooltipText} wrapperStyle={wrapperStyle} {...restProps} />;
  }

  return (
    <ActiveStatusChip
      appointmentDetails={appointmentDetails}
      isIntegrated={isIntegrated}
      wrapperStyle={wrapperStyle}
      {...restProps}
    />
  );
};
